module.exports = __webpack_public_path__ + "img/ic_Bitmap.fbf5cc87.png";